interface KilnShellMortarIndicatorProps {
  x: number
  y: number
  materialWidth: number
}

export const KilnShellMortarIndicator: React.FC<KilnShellMortarIndicatorProps> = ({
  x,
  y,
  materialWidth
}) => {
  return <rect x={x} y={y} width={materialWidth} height={4} fill="black" rx={2} />
}
